import React, { useState, useContext } from "react";
import { Button, Form, Input, Modal } from "antd";
import { omit } from "lodash";

import copy from "../../assets/images/webToLead/copy.png";
import { useLeadFormActions } from "./hooks/useLeadFormActions";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const Clone = ({ formData, setPage, isExpired, onSubscription }) => {
  const [form] = Form.useForm();
  const { showAlert } = useAlert();
  const { isWebToLeadCreate } = useContext(AuthContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newFormData, setNewFormData] = useState();
  const [isConfirm, setConfirm] = useState(false);
  const [error, setError] = useState();

  const { handleClone } = useLeadFormActions(
    () => {},
    () => {
      setConfirm(true);
      setIsModalOpen(false);
    }
  );

  const showModal = () => {
    if (isExpired) {
      onSubscription();
    } else {
      if (isWebToLeadCreate) {
        setIsModalOpen(true);
      } else {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to create web to lead form."
        );
      }
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setNewFormData();
    setError();
  };

  const onClone = async (values) => {
    setNewFormData(values);
    const payload = omit(
      {
        ...formData,
        ...values,
        createdDate: new Date(),
        updatedDate: new Date(),
      },
      ["id"]
    );
    const res = await handleClone(payload, 1, () => handleCancel());
    if (res?.status === "error") {
      setError(res?.message);
    }
    if (res?.data) {
      handleCancel();
      setPage(1);
    }
  };

  return (
    <>
      <div
        className="heading14px d-flex align-items-center"
        style={{ gap: 7, color: "#29292B", paddingRight: 30 }}
        onClick={showModal}
      >
        <img
          src={copy}
          alt=""
          style={{ width: 16, height: 16 }}
          className="cursor-pointer"
        />{" "}
        Clone
      </div>
      <Modal
        title={
          <div
            className="heading24px text-color-1C1C1C roboto-medium"
            style={{ padding: "20px 24px 10px" }}
          >
            Create Title for Clone
          </div>
        }
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          {error && <p className="text-error text-center pb-2">{error}</p>}

          <Form
            form={form}
            layout="vertical"
            initialValues={{ formName: "", domainName: "" }}
            onFinish={onClone}
          >
            <Form.Item
              label="Form Name:"
              name="formName"
              rules={[{ required: true, message: "Please enter a form name" }]}
            >
              <Input className="common-input" placeholder="Enter New Name…" />
            </Form.Item>

            <Form.Item
              label="Your Domain Name:"
              name="domainName"
              rules={[
                { required: true, message: "Please enter a domain name" },
                {
                  pattern:
                    /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/,
                  message:
                    "Please enter a valid domain name (e.g., example.com)",
                },
              ]}
            >
              <Input
                className="common-input"
                placeholder="Enter Your Domain Name…"
              />
            </Form.Item>

            <div
              className="mt40 d-flex justify-content-end align-items-center"
              style={{ gap: 20 }}
            >
              <Button className="secondary-btn" onClick={handleCancel}>
                Cancel
              </Button>
              <Button type="primary" className="theme-btn" htmlType="submit">
                Clone
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
      <Modal
        title="Subscription expired"
        open={isConfirm}
        centered
        width={400}
        footer={[
          <Button
            key="cancel"
            className="secondary-btn"
            onClick={() => {
              setNewFormData();
              setConfirm(false);
            }}
          >
            No
          </Button>,
          <Button
            key="ok"
            type="primary"
            className="theme-btn"
            onClick={() => {
              onClone({ ...newFormData, force: true });
              setConfirm(false);
            }}
          >
            Yes
          </Button>,
        ]}
        onOk={() => setConfirm(false)}
        onCancel={() => setConfirm(false)}
      >
        Your subscription has expired, but the grace period is still active. Do
        you want to continue for up to 7 more days?
      </Modal>
    </>
  );
};

export default Clone;
